<template>
<div>
	<div class="card" style="border: none!important;">
		<h3 class="clock" style="text-align: center; color: rgb(80, 80, 80); margin-bottom: 4px; font-weight: 500; font-size: 21px;"> Корисна інформація</h3>
<!-- 		<p>{{ now }}</p>  -->	</div>











	<div class="card" style="margin-top: -20px; ">
		<a target="_blank" href="https://www.mnau.edu.ua/">
			<svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 0 24 24" width="25" ><path d="M0 0h24v24H0z" fill="none"/><path fill="#636867" d="M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"/></svg>
			<p style="color: #000201; font-size: 16px;  padding-left: 15px;">Приймальна комісія МНАУ <br />
				<span style="color: #636867; font-size: 14px; ">Інформація для вступників</span>
			</p>
		</a>
	</div>

	<div class="card" style="margin-top: -20px; ">
		<a target="_blank" href="https://pk.mnau.edu.ua/junior-bachelor/">
			<svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 0 24 24" width="25"><path fill="none" d="M0 0h24v24H0V0z"/><path xmlns="http://www.w3.org/2000/svg" fill="#636867" d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/></svg>
			<p style="color: #000201; font-size: 16px;  padding-left: 15px;">Молодший бакалавр <br />
				<span style="color: #636867; font-size: 14px; ">освітній ступінь</span>
			</p>
		</a>
	</div>
	<div class="card" style="margin-top: -20px; ">
		<a target="_blank" href="https://pk.mnau.edu.ua/bachelor/">
			<svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 0 24 24" width="25"><path d="M0 0h24v24H0V0z" fill="none"/><path xmlns="http://www.w3.org/2000/svg" fill="#636867" d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"/></svg>
			<p style="color: #000201; font-size: 16px;  padding-left: 15px;">Бакалавр<br />
				<span style="color: #636867; font-size: 14px; ">освітній ступінь</span>
			</p>
		</a>
	</div>
	<div class="card" style="margin-top: -20px; ">
		<a target="_blank" href="https://pk.mnau.edu.ua/calculator-of-specialties/">
			<svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 0 24 24" width="25"><path d="M0 0h24v24H0V0z" fill="none" opacity=".87"/><path xmlns="http://www.w3.org/2000/svg" fill="#636867" d="M3 5v14h17V5H3zm4 2v2H5V7h2zm-2 6v-2h2v2H5zm0 2h2v2H5v-2zm13 2H9v-2h9v2zm0-4H9v-2h9v2zm0-4H9V7h9v2z"/></svg>
			<p style="color: #000201; font-size: 16px;  padding-left: 15px;">Калькулятор ЗНО<br />
				<span style="color: #636867; font-size: 14px; ">Перелік конкурсних предметів ЗНО</span>
			</p>
		</a>
	</div>
	<div class="card" style="margin-top: -20px; ">
		<a target="_blank" href="https://pk.mnau.edu.ua/faqs/">
			<svg xmlns="http://www.w3.org/2000/svg" height="25" viewBox="0 0 24 24" width="25"><path d="M0 0h24v24H0V0z" fill="none"/><path xmlns="http://www.w3.org/2000/svg" fill="#636867" d="M15 4v7H5.17l-.59.59-.58.58V4h11m1-2H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zm5 4h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1z"/></svg>
			<p style="color: #000201; font-size: 16px;  padding-left: 15px;">Запитання-відповіді <br />
				<span style="color: #636867; font-size: 14px; ">Відповіді на поширені запитання</span>
			</p>
		</a>
	</div>

	<div class="card ring" style="margin-top: -25px;">
		<h3 class="link"><svg style="transform: translateY(3px); margin:0px 0px 0 -5px;" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path fill="#28ac84" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/><circle fill="#28ac84" cx="12" cy="9" r="2.5"/></svg> м. Миколаїв, вул. Георгія Гонгадзе, 9</h3>
		<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2722.822108699315!2d31.962690915849343!3d46.96518507914744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40c5c940632c1dcd%3A0xa671d73a22df4f52!2z0YPQuy4g0JPQtdC-0YDQs9C40Y8g0JPQvtC90LPQsNC00LfQtSwgOSwg0J3QuNC60L7Qu9Cw0LXQsiwg0J3QuNC60L7Qu9Cw0LXQstGB0LrQsNGPINC-0LHQu9Cw0YHRgtGMLCA1NDAwMA!5e0!3m2!1sru!2sua!4v1582700152039!5m2!1sru!2sua" width="100%" height="450px" frameborder="0" style="border:0; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24); margin-top: 8px;" allowfullscreen="true"></iframe>
		
		<div style="height: 20px;"></div>
	</div>



</div>
</template>

<script>
export default {
	data () {
		return {
			now: 'loading...',
			timer: 0,
			timerkr: 0

				}
			},
	created: function() {
		this.clockLogic();
	},
	methods: {
		clockLogic: function() {
			setInterval(() => {
			var date = new Date();
			var hours = date.getHours();
			var minutes = date.getMinutes();
			var seconds = date.getSeconds();
			if (seconds < 10 ) {
				var fullSeconds = '0' + seconds;
			} else {
				var fullSeconds = seconds;
			}
			if (minutes < 10 ) {
				var fullMinutes = '0' + minutes;
			} else {
				var fullMinutes = minutes;
			}
			if (hours < 10 ) {
				var fullHours = '0' + hours;
			} else {
				var fullHours = hours;
			}
			this.hours = hours;
			this.minutes = minutes;
			this.seconds = seconds;
			this.now = fullHours + ':' + fullMinutes + ':' + fullSeconds;
			var prog = document.getElementsByClassName('progressStatus')
		// debugger;
		// 1 пара скрипт
		if (this.hours*60+this.minutes >= 8*60+30 && this.hours*60+this.minutes <= 9*60+50) {
		prog[0].style.width = ((this.hours*60+this.minutes)-(8*60+30))/80*100 + '%';
		this.timer = (((this.hours*60+this.minutes)-(8*60+30))-80)*(-1)
		} else if (this.hours*60+this.minutes > 9*60+50) {
			prog[0].style.width = '100%'
		} else {
			prog[0].style.width = '0%'
		};
		// 2 пара скрипт
		if (this.hours*60+this.minutes >= 10*60+5 && this.hours*60+this.minutes <= 11*60+25) {
		prog[1].style.width = ((this.hours*60+this.minutes)-(10*60+5))/80*100 + '%';
		this.timer = (((this.hours*60+this.minutes)-(10*60+5))-80)*(-1)
		} else if (this.hours*60+this.minutes > 11*60+25) {
			prog[1].style.width = '100%'
		} else {
			prog[1].style.width = '0%'
		};
		
		// 3 пара скрипт
		if (this.hours*60+this.minutes >= 11*60+55 && this.hours*60+this.minutes <= 13*60+15) {
		prog[2].style.width = ((this.hours*60+this.minutes)-(11*60+55))/80*100 + '%';
		this.timer = (((this.hours*60+this.minutes)-(11*60+55))-80)*(-1)
		} else if (this.hours*60+this.minutes > 13*60+15) {
			prog[2].style.width = '100%'
		} else {
			prog[2].style.width = '0%'
		};
		// 4 пара скрипт
		if (this.hours*60+this.minutes >= 13*60+30 && this.hours*60+this.minutes <= 14*60+50) {
		prog[3].style.width = ((this.hours*60+this.minutes)-(13*60+30))/80*100 + '%';
		this.timer = (((this.hours*60+this.minutes)-(13*60+30))-80)*(-1)
		} else if (this.hours*60+this.minutes > 14*60+50) {
			prog[3].style.width = '100%'
		} else {
			prog[3].style.width = '0%'
		};
		// 5 пара скрипт
		if (this.hours*60+this.minutes >= 15*60+5 && this.hours*60+this.minutes <= 16*60+25) {
		prog[4].style.width = ((this.hours*60+this.minutes)-(15*60+5))/80*100 + '%';
		this.timer = (((this.hours*60+this.minutes)-(15*60+5))-80)*(-1)
		} else if (this.hours*60+this.minutes > 16*60+25) {
			prog[4].style.width = '100%'
		} else {
			prog[4].style.width = '0%'
		}
		// 6 пара скрипт
		if (this.hours*60+this.minutes >= 16*60+40 && this.hours*60+this.minutes <= 18*60) {
		prog[5].style.width = ((this.hours*60+this.minutes)-(16*60+40))/80*100 + '%';
		this.timer = (((this.hours*60+this.minutes)-(16*60+40))-80)*(-1)
		} else if (this.hours*60+this.minutes > 18*60) {
			prog[5].style.width = '100%'
		} else {
			prog[5].style.width = '0%'
		}

		// 1 кр пара скрипт
		if (this.hours*60+this.minutes >= 9*60 && this.hours*60+this.minutes <= 10*60+20) {
		prog[6].style.width = ((this.hours*60+this.minutes)-(9*60))/80*100 + '%';
		this.timerkr = (((this.hours*60+this.minutes)-(9*60))-80)*(-1)
		} else if (this.hours*60+this.minutes > 10*60+20) {
			prog[6].style.width = '100%'
		} else {
			prog[6].style.width = '0%'
		}

		// 2 кр пара скрипт
		if (this.hours*60+this.minutes >= 10*60+35 && this.hours*60+this.minutes <= 11*60+55) {
		prog[7].style.width = ((this.hours*60+this.minutes)-(10*60+35))/80*100 + '%';
		this.timerkr = (((this.hours*60+this.minutes)-(10*60+35))-80)*(-1)
		} else if (this.hours*60+this.minutes > 11*60+55) {
			prog[7].style.width = '100%'
		} else {
			prog[7].style.width = '0%'
		}

		// 3 кр пара скрипт
		if (this.hours*60+this.minutes >= 12*60+25 && this.hours*60+this.minutes <= 13*60+45) {
		prog[8].style.width = ((this.hours*60+this.minutes)-(12*60+25))/80*100 + '%';
		this.timerkr = (((this.hours*60+this.minutes)-(12*60+25))-80)*(-1)
		} else if (this.hours*60+this.minutes > 13*60+45) {
			prog[8].style.width = '100%'
		} else {
			prog[8].style.width = '0%'
		}

		// 4 кр пара скрипт
		if (this.hours*60+this.minutes >= 14*60 && this.hours*60+this.minutes <= 15*60+20) {
		prog[9].style.width = ((this.hours*60+this.minutes)-(14*60))/80*100 + '%';
		this.timerkr = (((this.hours*60+this.minutes)-(14*60))-80)*(-1)
		} else if (this.hours*60+this.minutes > 15*60+20) {
			prog[9].style.width = '100%'
		} else {
			prog[9].style.width = '0%'
		}

		// 5 кр пара скрипт
		if (this.hours*60+this.minutes >= 15*60+35 && this.hours*60+this.minutes <= 16*60+55) {
		prog[10].style.width = ((this.hours*60+this.minutes)-(15*60+35))/80*100 + '%';
		this.timerkr = (((this.hours*60+this.minutes)-(15*60+35))-80)*(-1)
		} else if (this.hours*60+this.minutes > 16*60+55) {
			prog[10].style.width = '100%'
		} else {
			prog[10].style.width = '0%'
		}

		// 6 кр пара скрипт
		if (this.hours*60+this.minutes >= 17*60+10 && this.hours*60+this.minutes <= 18*60+30) {
		prog[11].style.width = ((this.hours*60+this.minutes)-(17*60+10))/80*100 + '%';
		this.timerkr = (((this.hours*60+this.minutes)-(17*60+10))-80)*(-1)
		} else if (this.hours*60+this.minutes > 18*60+30) {
			prog[11].style.width = '100%'
		} else {
			prog[11].style.width = '0%'
		}









		}, 1000);
		}
	}
}
</script>

<style>
	h2 {

		color: #28ac84;
		font-size: 24px;
			}
</style>
<style scoped>
	.card a {
	margin-bottom: -5px;
	display: flex; flex-direction: row; align-items: center; text-decoration: none;
}
.card a p, .card a span {
	font-weight: 600;
}








	.timer {
		color: #292e31; 
		margin: -5px 0 21px;
		font-weight: 600;
	}
	.card {
		width: 90vw;
	}
	h3 {
		margin-top: 20px!important;
	}
	h2>span {
		color: #636867;
		font-size: 18px;
		display: block;
	}
	.ring {
		
	}
	.ring p {
		font-size: 16px;
		color: #292e31;
		font-weight: 600;
		position: relative;
	}
	.ring span {
		position: absolute;
		right: 0;
		color: #636867;
		font-size: 14px;
	}
	.progressBar {
		background-color: #e9e9e7;
		width: 100%;
		
		height: 2px;
		margin-top: -9px;
    	margin-bottom: 12px;
    	overflow: hidden;
    	border-radius: 5px;
	}
	.progressStatus {
		background-color: #28ac84;
		height: 10px;
		width: 0%;
		transition: all 0.1s ease-out;
	}
	.clock {
		margin-top: 30px;
		color: #28ac84;
		font-weight: 500;
		font-size: 24px;
		transform: translateY(-10px);
	}
	.clock+p {
		font-weight: 500;
		color: #636867;
		font-size: 14px;
		margin-top: -31px!important;

	}
</style>


// WEBPACK FOOTER //
// src/Clock.vue